export enum ClientIdentifierTiketActions {
  add = 'TicketPayIn',
  payin = 'TicketPayIn',
  payout = 'TicketPayOut',
  cancel = 'TicketCancel',
}
